<template>
  <div>
    <vs-popup
      class="holamundo"
      :title="$t('skillDetails.endorsement.e1')"
      :active.sync="goalCompletedPopup"
      :button-close-hidden="true"
    >
      <div>
        <div class="mb-base text-center">
            <span class="text-center text-primary" style="font-size: 22px;">
              {{ $t('skillDetails.endorsement.e2') }}
            </span>
        </div>
        <div class="mt-2 mb-2 text-center">
          <img
            src="@/assets/Illustrations/Ill_History.svg"
            alt="send endorsement invite"
            width="200px"
            height="200px"
          />
        </div>
        <div class="w-full items-center">
          <vs-button @click="addAnotherSkill" size="medium">{{ $t('skillDetails.endorsement.e3') }}</vs-button>
        </div>
      </div>
    </vs-popup>
    <div class="vx-row">
      <div class="vx-card w-full no-box-shadow overflow-hidden mb-base">
        <!---->
        <div class="vx-card__collapsible-content vs-con-loading__container">
          <div
            v-if="
              Object.keys(this.$store.state.endorsementInvite.chartObj)
                .length === 0
            "
          >
            <div
              class="con-vs-avatar mx-auto my-6 block 80px"
              style="width: 250px; height: 200px; background: white/*rgb(195, 195, 195)*/;"
            >
              <!---->
              <div class="">
                <img
                  src="@/assets/Illustrations/Ill_Skill Details_Endorsement.svg"
                  alt=""
                  style="color: grey;"
                />
              </div>
            </div>
            <div class="p-6 text-center">
              <!--<span
              class="p-3 inline-flex rounded-full feather-icon select-none relative text-warning mb-4"
              style="background: rgba(var(&#45;&#45;vs-primary),0.15);"
            >
              <img src="@/assets/Illustrations/Ill_Skill Details_Progress.svg" alt="attribute" class="skill-icon" />
            </span>-->
              <div class="truncate t-sd mb-2">
                <h5 class="mb-2 text-primary">
                  {{ $t('skillDetails.endorsement.e4') }}<br>
                  <vs-button
                    v-if="progressStatus !== 'complete' && userType === 'trainee'"
                    class="mt-4"
                    @click="sendInvite"
                  >{{ $t('skillDetails.endorsement.e6') }}</vs-button
                  ><vs-button
                  v-else-if="progressStatus !== 'complete' && userType === 'coach' && terminology==2"
                  @click="sendInvite"
                >{{ $t('skillDetails.endorsement.e6') }}</vs-button
                >
                </h5>

                <span
                >{{ $t('skillDetails.endorsement.e5') }}</span
                >
              </div>
              <div class="mb-base items-left">
                <!--                <h6 class="mb-2">{{ $t("skillDetails.details.d4") }}</h6>-->
                <div class="vx-row">

                  <!--                  {{progress_measures_list}}-->
                  <div
                    v-for="(p, indexp) in progress_measures_list"
                    :key="indexp"
                    class="vx-col w-full"
                  >
                    <div class="vx-card overflow-hidden mb-2">
                      <!---->
                      <div
                        class="vx-card__collapsible-content vs-con-loading__container"
                      >
                        <div>
                          <!-- Replace this specific section inside your v-for loop in the template -->
                          <div class="p-6 flex items-center">
                            <!-- Added flex-shrink-0 so the icon doesn't get squished by the text -->
                            <span
                              class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon flex-shrink-0"
                              style="background: rgba(var(--vs-primary),0.15);"
                            >
                              <img
                                :src="require('@/assets/Iconography/Progress measures/PM_' + (parseInt(indexp) + 1) + '.svg')"
                                alt="pm"
                                width="30px"
                                height="30px"
                              />
                            </span>

                            <!-- Updated layout block to render the Title above pmMap -->
                            <div class="mb-1 ml-4 w-full text-left" style="line-height: 1.5;">
                              <h5 v-if="p.title" class="font-bold text-gray-800 mb-1" style="color: #1F2937; font-weight: 700;">
                                {{ p.title }}
                              </h5>
                              <span>{{ p.pmMap }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>


            </div>

            <!---->
          </div>
          <div v-else>
            <div class="p-6 text-center mb-base">
              <div class="mb-base">
                <EndorsementChart />
                <!--<vs-list>
                <vs-list-item
                  v-for="email in endorsement_invite_emails"
                  :key="email"
                  :title="email"
                >
                  <vs-chip color="warning">Not Submitted</vs-chip>
                </vs-list-item>
              </vs-list>-->
              </div>
              <vs-button
                v-if="progressStatus !== 'complete' && userType === 'trainee'"
                @click="sendInvite"
              >{{ $t('skillDetails.endorsement.e6') }}</vs-button
              >
              <vs-button
                v-else-if="progressStatus !== 'complete' && userType === 'coach' && terminology==2"
                @click="sendInvite"
              >{{ $t('skillDetails.endorsement.e6') }}</vs-button
              >

            </div>

            <div class="vx-row" style="margin-left:10%;">

              <!--<span
              class="p-3 inline-flex rounded-full feather-icon select-none relative text-warning mb-4"
              style="background: rgba(var(&#45;&#45;vs-primary),0.15);"
            >
              <img src="@/assets/Illustrations/Ill_Skill Details_Progress.svg" alt="attribute" class="skill-icon" />
            </span>-->
              <!-------Email-Flow-Change-27-09-2020-- Start--->
              <vs-popup   :title="$t('skillDetails.action2.a25')" :active.sync="confirmcancelSingleEmail" >
                <div class="con-exemple-prompt">
                  <div class="con-exemple-prompt">
                    {{$t('skillDetails.action2.a24')}}  <b></b>  ?
                  </div>
                  <vs-button
                    class="ml-4 mt-4 float-right"
                    @click="confirmCancelSingleEmail(externalFeedbackId)"
                  >Ok</vs-button>
                </div>
              </vs-popup>
              <vs-popup   :title="$t('skillDetails.action2.a26')" :active.sync="confirmExpireSingleEmail" >
                <div class="con-exemple-prompt">
                  <div class="con-exemple-prompt">
                    {{$t('skillDetails.action2.a27')}}  <b></b>  ?
                  </div>
                  <vs-button
                    class="ml-4 mt-4 float-right"
                    @click="confirmExpireTokenSingleEmail(externalFeedbackId)"
                  >Ok</vs-button>
                </div>
              </vs-popup>
              <vs-popup  :title="$t('skillDetails.action2.a1')+inviteUserName" :active.sync="scheduleInvite" >
                <div class="con-exemple-prompt"
>
                  <vs-list-item v-for="(date, index) in feedback_sent_dates" :title="date.finalDate" >

                    <table style="width:100%;overflow-x: hidden;">

                      <tr v-if="(new Date(date.feedbackSentDate)) <(new Date()) &&  date.emailStatus===0">
                        <b>{{$t('skillDetails.action2.a8')}}</b>
                        <a
                          size="small"
                          title="System follow-up is sent once, follow-up again with your personal email"
                          class="ml-2"
                          @click="sendFollowupMail(date.id)"
                        >{{$t('skillDetails.action2.a9')}}</a
                        >
<!--                        <a :href="'mailto:'+email[0].inviteeEmail+'?subject=Coach Feedback request from'+traineeName+' &body=http://localhost:8080/user/endorsement-invite/response/followup/'+date.externalToken+'?inviteename='+inviteUserName+'%26traineename='+traineeName+'%26lang=en'">Link</a>-->
<!--                      -->
                        <feather-icon
                          v-if="userType==='admin'"
                          icon="AlertTriangleIcon"
                          class="ml-2 "
                          title="Expire Email"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="expireTokenSingleEmail(date.id)"
                        />
                      </tr>
                      <tr v-else-if="(date.currentGap >0) &&  date.emailStatus===1 && index===0 ">
                        <b>{{$t('skillDetails.action2.a30')}}</b>
                      </tr>
                      <tr v-else-if="(date.currentGap >0) &&  date.emailStatus===1 && index>0">
                        <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a10')}}</b>
                      </tr>
                      <tr v-else-if="(new Date(date.feedbackSentDate)) <(new Date()) &&date.emailStatus===0 &&date.externalTokenExpired===1 ">
                        <b>{{$t('skillDetails.action2.a8')}}</b>
                        <vs-button
                          size="small"
                          class="ml-2"
                          disabled
                          @click="sendFollowupMail(date.id)"
                          title="Followup already send"
                        >{{$t('skillDetails.action2.a9')}}</vs-button
                        >
                        <feather-icon
                          v-if="userType==='admin'"
                          icon="AlertTriangleIcon"
                          class="ml-2"
                          title="Expire Email"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="expireTokenSingleEmail(date.id)"
                        />

                      </tr>
    <tr v-else-if="(new Date(date.feedbackSentDate)) <(new Date()) &&date.emailStatus===6 &&date.externalTokenExpired===1 ">
                        <b class="mr-4">{{$t('skillDetails.action2.a8')}}</b>
      <b>{{$t('skillDetails.action2.a23')}}</b>
    </tr>
                      <tr v-else-if="(date.currentGap === -1 && date.emailStatus===4)">
                        <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a18')}}</b>
                      </tr>
                      <!----Status Followup-disabled ---->
                      <tr v-else-if="(new Date(date.feedbackSentDate)) <(new Date()) &&date.emailStatus===1 ">
                        <b>{{$t('skillDetails.action2.a8')}}</b>
                        <vs-button
                          size="small"
                          class="ml-4"
                          disabled
                          @click="sendFollowupMail(date.id)"
                          title="Followup already send"
                        >{{$t('skillDetails.action2.a9')}}</vs-button
                        >
                        <feather-icon
                          v-if="userType==='admin'"
                          icon="AlertTriangleIcon"
                          class="ml-2 "
                          title="Expire Email"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="expireTokenSingleEmail(date.id)"
                        />
                      </tr>
                      <!----Status Followup-disabled ---->
                      <tr v-else-if="(new Date(date.feedbackSentDate)) >(new Date()) && date.emailStatus===0">
                        <b>{{$t('skillDetails.action2.a12')}}</b>

                        <feather-icon
                        v-if="userType==='admin'"
                        icon="MailIcon"
                        class="ml-4"
                        @click="cancelSingleEmail(date.id)"
                        title="Cancel Email"
                        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                      />
                      </tr>
                      <tr v-else-if="(date.currentGap >0 && date.emailStatus ===4 && index>0)">
                        <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a10')}}</b>
                      </tr> <tr v-else-if="(date.currentGap >0 && date.emailStatus ===4 && index===0)">
                        <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a30')}}</b>
                      </tr>
                      <tr v-else-if="(date.currentGap === 0 && date.emailStatus===5)">
                        <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a11')}}</b>
                      </tr>  <tr v-else-if="(date.currentGap === 0 && date.emailStatus===4)">
                        <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a11')}}</b>
                      </tr>  <tr v-else-if="(date.externalTokenExpired === 1 && date.emailStatus===1)">
                        <b>{{$t('skillDetails.action2.a13')}}</b>
                      </tr>
                      <tr v-else-if="(date.externalTokenExpired === 1 && date.emailStatus===6)">
                        <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a28')}}</b>
                      </tr>
                      <tr v-else-if="date.emailStatus===2">
                        <b>{{$t('skillDetails.action2.a8')}}</b>
                        <vs-button
                          size="small"
                          class="ml-4"
                          @click="sendFollowupMail(date.id)"
                          title="Followup already send"
                        >{{$t('skillDetails.action2.a9')}}</vs-button
                        >
                         <br>
                             <p v-if="date.followupCount===1">Followed up {{date.followupCount}} times</p>
                             <p v-else>Followed up {{date.followupCount}} times</p>
                        <feather-icon
                          v-if="userType==='admin'"
                          icon="AlertTriangleIcon"
                          class="ml-2"
                          title="Expire Email"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="expireTokenSingleEmail(date.id)"
                        />
                      </tr>

                      <!--                      <tr v-else-if="date.emailStatus===1">-->
                      <!--                        <b>{{$t('skillDetails.action2.a13')}}</b>-->
                      <!--                      </tr>-->
                    </table>
                  </vs-list-item>
                  <vs-button
                    class="ml-4 mt-4 float-right"
                    @click="cancelScheduleEmail(email)"
                  >{{$t('skillDetails.action2.a3')}}</vs-button>
                </div>

              </vs-popup>
              <vs-popup   :title="$t('skillDetails.action2.a1')" :active.sync="confirmscheduleInvite" >
                <div class="con-exemple-prompt">
                  <div class="con-exemple-prompt">
                    {{$t('skillDetails.action2.a5')}}  <b>{{email}}</b> ?
                  </div>
                  <vs-button
                    class="ml-4 mt-4 float-right"
                    @click="confirmscancelScheduleEmail(edorsementId)"
                  >Ok</vs-button>
                </div>
              </vs-popup>
              <vs-popup   :title="$t('skillDetails.action2.a1')" :active.sync="sentCancelEmailPopup" >
                <div class="con-exemple-prompt">
                  <div class="con-exemple-prompt">
                    {{$t('skillDetails.action2.a29')}}
                  </div>
                  <vs-button
                    class="ml-4 mt-4 float-right"
                    @click="sentCancelEmailPopupClose()"
                  >Ok</vs-button>
                </div>
              </vs-popup>
              <vs-popup   :title="$t('skillDetails.action2.a1')+inviteUserName" :active.sync="resetscheduleInvite" >
                <div class="con-exemple-prompt">
                  <vs-list-item v-for="(date  ,index) in feedback_sent_dates" :title="formatDate(date.feedbackSentDate)" >
                    <table style="width:100%">
                      <tr v-if="(new Date(date.feedbackSentDate)) <(new Date()) &&  date.emailStatus===0">
                        <b>{{$t('skillDetails.action2.a8')}}</b>
                        <vs-button
                          size="small"
                          class="ml-4"
                          @click="sendFollowupMail(date.id)"
                        >{{$t('skillDetails.action2.a9')}}</vs-button
                        >
                        <feather-icon
                          v-if="userType==='admin'"
                          icon="AlertTriangleIcon"
                          class="ml-2 "
                          title="Expire Email"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="expireTokenSingleEmail(date.id)"
                        />
                        </tr>
                      <tr v-else-if="(date.currentGap >0 && date.emailStatus===1 && index>0)">
                        <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a10')}}</b>
                      </tr><tr v-else-if="(date.currentGap >0 && date.emailStatus===1 && index===0)">
                        <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a30')}}</b>
                      </tr>
                      <tr v-else-if="date.emailStatus===4">
                        <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a10')}}</b>
                      </tr>
                      <tr v-else-if="date.emailStatus===4 && date.emailStatus===4 && index>0">
                        <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a10')}}</b>
                      </tr><tr v-else-if="date.emailStatus===4 && date.emailStatus===4 && index===0">
                        <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a30')}}</b>
                      </tr>
                      <tr v-else-if="(date.currentGap === 0 && date.emailStatus===5)">
                        <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a11')}}</b>
                      </tr>
                      <tr v-else-if="(date.externalTokenExpired === 1 && date.emailStatus===6)">
                        <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a28')}}</b>
                      </tr>
                      <tr v-else-if="date.emailStatus===2">
                        <b>{{$t('skillDetails.action2.a8')}}</b>
                        <vs-button
                          size="small"
                          class="ml-4"
                          @click="sendFollowupMail(date.id)"
                        >{{$t('skillDetails.action2.a9')}}</vs-button
                        >
                        <feather-icon
                          v-if="userType==='admin'"
                          icon="AlertTriangleIcon"
                          class="ml-2 "
                          title="Expire Email"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="expireTokenSingleEmail(date.id)"
                        />

                      </tr>
                      <tr v-else-if="(new Date(date.feedbackSentDate)) <(new Date()) &&date.emailStatus===6 &&date.externalTokenExpired===1 ">
                        <b class="mr-4">{{$t('skillDetails.action2.a8')}}</b>
                        <b>{{$t('skillDetails.action2.a23')}}</b>


                      </tr>
                      <tr v-else-if="(new Date(date.feedbackSentDate)) >(new Date()) && date.emailStatus===0">
                        <b>{{$t('skillDetails.action2.a12')}}</b>
                        <feather-icon
                          v-if="userType==='admin'"
                          icon="MailIcon"
                          class="ml-4 "
                          @click="cancelSingleEmail(date.id)"
                          title="Cancel Email"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                                                 />

                      </tr>
                      <tr v-else-if="date.emailStatus===1">
                        <b>{{$t('skillDetails.action2.a13')}}</b>
                      </tr>
                    </table>
                  </vs-list-item>
                  <vs-button
                    class="ml-4 mt-4 float-right"
                    @click="resetScheduleEmail(email)"
                  >{{$t('skillDetails.action2.a4')}}</vs-button>
                </div>
              </vs-popup>
              <vs-popup   :title="$t('skillDetails.action2.a1')+inviteUserName" :active.sync="markGoalCompletedEmail" >
                <div class="con-exemple-prompt">
                  <vs-list-item v-for="(date,index) in feedback_sent_dates" :title="formatDate(date.feedbackSentDate)" >
                    <table style="width:100%">
                      <tr v-if="(new Date(date.feedbackSentDate)) <(new Date()) && date.emailStatus===0">
                        <b>{{$t('skillDetails.action2.a8')}}</b>
                      </tr>
                      <tr v-else-if="date.emailStatus===2">
                        <b>Sent</b>
                      </tr>
                      <tr v-else-if="date.emailStatus===6">
                        <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a28')}}</b>
                      </tr>
                      <tr v-else-if="date.emailStatus===1 && date.currentGap===''">
                        <b>{{$t('skillDetails.action2.a13')}}</b>
                      </tr>

                      <tr v-else-if="date.emailStatus===5">
                        <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a11')}}</b>
                      </tr>
                      <tr v-else-if="date.emailStatus===4 || (date.currentGap>0 && index>0)">
                        <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a10')}}</b>
                      </tr>  <tr v-else-if="date.emailStatus===4 || (date.currentGap>0 && index===0)">
                        <b :title="date.notesDescription?date.notesDescription:'No Note Added'">{{$t('skillDetails.action2.a30')}}</b>
                      </tr>
                    </table>
                  </vs-list-item>
                </div>
              </vs-popup>
              <vs-popup   :title="$t('skillDetails.action2.a1')" :active.sync="confirmResetscheduleInvite" >
                <div class="con-exemple-prompt">
                  <div class="con-exemple-prompt">
                    {{$t('skillDetails.action2.a6')}}  <b>{{email}}</b>  ?
                  </div>
                  <vs-button
                    class="ml-4 mt-4 float-right"
                    @click="confirmresetScheduleEmail(emailScheduleData)"
                  >Ok</vs-button>
                </div>
              </vs-popup>
              <vs-popup   :title="$t('skillDetails.action2.a15')" :active.sync="markGoalCompletedConfirmation" >
                <div class="con-exemple-prompt">
                  <div class="con-exemple-prompt">
                    {{$t('skillDetails.action2.a16')}}
                  </div>
                  <vs-button
                    class="ml-4 mt-4 float-right"
                    @click="markGoalComplete()"
                  >{{$t('skillDetails.action2.a17')}}</vs-button>
                </div>
              </vs-popup>
            </div>
            <vs-collapse accordion >
                 <vs-collapse-item>
                   <div slot="header" style="font-size:12px;" class="left">   <b >Cancel / Reschedule</b></div>

                   <table>
              <tr>
                <th> <b style="font-size:12px;"> {{$t('Invited')}}</b></th>
              </tr>

              <tr v-for="e in inviteeEmail">
                <td v-if="userType === 'trainee'">
                  <table class="w-full mx-0" v-if="e.status===0 || e.status === null">
                    <tr>
                      <td class="left"><b>{{e.inviteeEmail}}</b></td>
                      <td class="right"> <feather-icon
                            icon="Edit3Icon"
                            svgClasses="h-5  float-right hover:text-primary cursor-pointer" @click="scheduleSendEndorsementInvite(e.id)" type="filled"
                          >
                          </feather-icon>
                          <feather-icon icon="TrashIcon" svgClasses="h-5 float-right hover:text-primary cursor-pointer" @click="removeInvited(e.id)" type="filled"></feather-icon>
                      </td>
                    </tr>
                  </table>
                </td>

                <td v-else-if="userType === 'coach' && terminology==2">
                  <table class="w-full mx-0" >
                    <tr>

                      <td class="left"><b>{{e.inviteeEmail}}</b></td>
                      <td class="left">{{(e.status===0 || e.status === null) ?'active':'deactive'}}</td>
                      <td class="right"> <feather-icon
                        icon="Edit3Icon"
                        svgClasses="h-5  float-right hover:text-primary cursor-pointer" @click="scheduleSendEndorsementInvite(e.id)" type="filled"
                      >
                      </feather-icon>
                        <feather-icon v-if="userType==='coach' && e.status===0" icon="TrashIcon" svgClasses="h-5 float-right hover:text-primary cursor-pointer" @click="removeInvited(e.id)" type="filled"></feather-icon>
                        <feather-icon v-if="userType==='coach' && e.status===1" icon="RefreshCwIcon"
                                      svgClasses="h-5  float-right hover:text-primary cursor-pointer" @click="reactiveInvitee(e.id)" type="filled">
                        </feather-icon>
                      </td>
                    </tr>
                  </table>
                </td>
                <td v-else>
                  <table class="w-full mx-0">
                    <tr>

                      <td class="left"><b>{{e.inviteeEmail}}</b></td>
                      <td class="left">{{(e.status===0 || e.status === null) ?'active':'deactive'}}</td>
                      <td class="right"> <feather-icon
                              icon="Edit3Icon"
                              svgClasses="h-5  float-right hover:text-primary cursor-pointer" @click="scheduleSendEndorsementInvite(e.id)" type="filled"
                            >
                            </feather-icon>
                            <feather-icon v-if="userType==='admin' && e.status===0" icon="TrashIcon" svgClasses="h-5 float-right hover:text-primary cursor-pointer" @click="removeInvited(e.id)" type="filled"></feather-icon>
                            <feather-icon v-if="userType==='admin' && e.status===1" icon="RefreshCwIcon"
                            svgClasses="h-5  float-right hover:text-primary cursor-pointer" @click="reactiveInvitee(e.id)" type="filled">
                            </feather-icon>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
              </vs-collapse-item>
            </vs-collapse>
            <!-------Email-Flow-Change-27-09-2020---End--->

            <div class="p-6 text-center">
              <div class="mb-base">
                <vs-button
                  v-if="progressStatus === 'complete'"
                  disabled
                  size="large"
                  @click="markGoalConfirmComplete"
                  color="black"
                >{{ $t('skillDetails.endorsement.e1') }}</vs-button
                >

                <vs-button
                  v-else-if="progressStatus === 'in_progress' && userType === 'trainee'"
                  size="large"
                  @click="markGoalConfirmComplete"
                  color="black"
                >{{ $t('skillDetails.endorsement.e7') }}</vs-button
                >  <vs-button
                  v-else-if="progressStatus === 'in_progress' && userType === 'coach' && terminology==2"
                  size="large"
                  @click="markGoalConfirmComplete"
                  color="black"
                >{{ $t('skillDetails.endorsement.e7') }}</vs-button
                >
              </div>
            </div>
          </div>

          <!----><!---->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EndorsementChart from "../components/EndorsementChart";
import i18n from "@/i18n/i18n";

// MUST BE HERE: Outside and above "export default {"
import baseData from "@/i18n/i18n-en-Data-DPM.js";
import deepData from "@/i18n/i18n-en-deep-Data.js";
import pciData from "@/i18n/i18n-en-pci-Data-Coach.js";
import peopletreeData from "@/i18n/i18n-en-peopletree-Data.js";

export default {
  name: "Endorsement",
  components: { EndorsementChart },
  props: ["progressStatus","terminology"], // "terminology" is declared here as a prop
  data() {
    return {
      userType: this.$store.state.AppActiveUser.userType,
      endorsement_invite_data: null,
      endorsementInvitePrgmsId:'',
      endorsement_invite_emails: [],
      feedback_sent_dates: [],
      inviteeEmail:{},
      inviteUserName:null,
      confirmcancelSingleEmail:false,
      confirmExpireSingleEmail:false,
      externalFeedbackId:null,
      endorsementChartObj: {},
      endorsementNewObj: {},
      progress_measures_list: [],
      custom_progress_measures: [],
      
      // ❌ REMOVED: terminology: null, (fixes the Vue warning)
      
      CCD: this.$t("addNewSkill.data"),
      themeColors: [
        "#FF7F00", "#FF0000", "#9400D3", "#0000FF", "#FFFF00",
        '#7367F0', '#28C76F', '#EA5455', '#FF9F43',
        '#1E1E1E','#4800FF','#606060','#7F0000',
        '#FF006E','#0094FF','#00FFFF','#007F46',
        '#7F6A00','#FF7F7F','#7F0037','#007F0E',
        '#7FC9FF','#B200FF','#FF6A30','#7FFFC5',
        '#FFE97F','#7F92FF','#D67FFF','#007F7F'
      ],
        goalCompletedPopup: false,
        scheduleInvite: false,
        confirmscheduleInvite:false,
        sentCancelEmailPopup:false,
        resetscheduleInvite:false,
        confirmResetscheduleInvite:false,
        markGoalCompletedConfirmation:false,
        email:'',
        endorsementInvitePrgms:null,
        edorsementId:'',
        compenTencyId:'',
        emailScheduleData:{},
        skillName:"",
        training_duration:"",
        cancelDisable:true,
        traineeName:"",
        markGoalCompletedEmail:false
      };
    },
    computed: {
      coachType(){
        if(window.$cookies.get('companyName')==='GALA.GAMES'){
          return "Mentor";

        }else{
          return "Coach";
        }
      }
    },
    methods: {
      onlyBenchmark() {
      },
      findProgressMeasureData(pmId) {
      console.log(`[PM Lookup] Searching for progress measure ID: ${pmId}`);
      
      // The array order defines priority. PCI is checked first as the default/priority.
      const dataSources = [
        { name: 'PCI', data: pciData },
        { name: 'DPM', data: baseData },
        { name: 'DEEP', data: deepData },
        { name: 'PeopleTree', data: peopletreeData }
      ];

      // A robust recursive function to search through ANY nested object/array structure
      const deepSearch = (obj, targetId) => {
        // Base case: if it's not an object or is null, stop searching this branch
        if (!obj || typeof obj !== 'object') return null;

        // Condition 1: The object itself has an 'id' matching what we want AND contains PM data
        if (obj.id === targetId && (obj.pm !== undefined || obj.pmMap !== undefined)) {
            return obj;
        }

        // Iterate over all keys in the current object/array
        for (let key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                
                // Condition 2: Sometimes IDs are used as object keys instead of properties (e.g., "sd-1-0": { pm: "..." })
                if (key === targetId && typeof obj[key] === 'object' && (obj[key].pm !== undefined || obj[key].pmMap !== undefined)) {
                    return { id: targetId, ...obj[key] };
                }
                
                // Recursively search deeper into the children
                const result = deepSearch(obj[key], targetId);
                
                // If we found it deep down, bubble it all the way up
                if (result) return result;
            }
        }
        return null; // Not found in this branch
      };

      // Search through each framework file based on priority
      for (const source of dataSources) {
        try {
          // Normalize the exported data
          const targetData = source.data.default || source.data;
          
          // Trigger the recursive deep search
          const pmFound = deepSearch(targetData, pmId);
          
          if (pmFound) {
              console.log(`[PM Lookup] Found correct PM data in ${source.name} for ID: ${pmId}`, pmFound);
              return pmFound;
          }
        } catch (e) {
          console.error(`[PM Lookup] Error searching in ${source.name} for ${pmId}:`, e);
        }
      }

      console.warn(`[PM Lookup] Could not find PM data for ID: ${pmId} across prioritized datasets.`);
      return null;
    },
      scheduleSendEndorsementInvite(id){
        console.log('endEndorsementInviteId',id);
        console.log('app active user',this.$store.state.AppActiveUser);
        this.traineeName=this.$store.state.AppActiveUser.firstName+' '+this.$store.state.AppActiveUser.lastName;
        const query={query:{
            endorsementInviteId:id}}
        this.$store
          .dispatch("endorsementInvite/fetchInviteePrgms", query)
          .then(res => {
            console.log("invitee data", res);
            let query1={},query2={}, count=0;
            for(let j=0;j<res.data.length;j++){
              for(let k=0;k<res.data[j].externalFeedback.length;k++){
                count=count+res.data[j].externalFeedback[k].externalTokenExpired;
              }
            }
            // Count  All External Token Expired For Completed
            if(count===res.data.length*6){
              const query3= {
                query: {
                  endorsementInvitePrgmsId: res.data[res.data.length-1].id,
                }
              }
              this.$store
                .dispatch("endorsementInvite/fetchFeeddata", query3)
                .then(res1 => {
                  console.log('',res1);
                  let count = 1;
                  let count1 = 1;
                  for (let i = 0; i < res1.data.length; i++) {
                    if ((new Date(res1.data[i].feedbackSentDate)) > (new Date())) {
                      if (res1.data[i].emailStatus === 1) {
                        count = count + res1.data[i].emailStatus;
                        console.log('C', count);
                      } else if (res1.data[i].emailStatus === 5 || res1.data[i].emailStatus === 6) {
                        count1 = count + res1.data[i].emailStatus;
                        console.log('C', count);
                      } else {

                      }
                    }
                  }
                  if ((count - 1)
                    > 0 && (count - 1)
                    <= 5) {
                    this.scheduleInvite = false;
                    this.resetscheduleInvite = true;
                    this.markGoalCompletedEmail = false;
                  } else if (count1 - count > 0) {
                    this.scheduleInvite = false;
                    this.resetscheduleInvite = false;
                    this.markGoalCompletedEmail = true;
                  } else {
                    this.scheduleInvite = true;
                    this.resetscheduleInvite = false;
                    this.markGoalCompletedEmail = false;
                  }
                  for(let k=0;k<res1.data.length;k++){
                    if(res1.data[k]["feedbackReceivedDate"]!==null){
                      res1.data[k]["finalDate"]=res1.data[k]["feedbackSentDate"]+' / '+res1.data[k]["feedbackReceivedDate"];
                    }else{
                      res1.data[k]["finalDate"]=res1.data[k]["feedbackSentDate"];
                    }
                  }
                  this.feedback_sent_dates = res1.data;
                  console.log('faadback data all',res1.data);
                  this.edorsementId = res1.data;
                  const query2 = {query: {id: id}}
                  this.$store
                    .dispatch("endorsementInvite/fetchInvitees", query2)
                    .then(res => {
                      this.email = res.data;
                      this.compenTencyId = res.data[0].traineeCompetenciesId;
                      this.inviteUserName=res.data[0].inviteUserName;
                      this.$store
                        .dispatch("addSkill/findCompetency",{query:{id:this.compenTencyId}})
                        .then(traineeCompetency =>{
                          const date=new Date (traineeCompetency.data[0].trainingDuration);
                          this.training_duration= date.getDate()+'/'+ date.getMonth()+'/'+date.getFullYear();
                          const competencyId =  traineeCompetency.data[0].competencyId.split("-")[0];
                          console.log(competencyId);
                          const competencies = this.CCD[competencyId].competencies;
                          console.log(competencies);
                         // const currentCompetency = competencies[competencyId];
                         // this.skillName = competencies.comp;
                         // console.log(this.skillName);
                        }).catch(err => {
                        console.log("data not found", err);
                      });
                      console.log("email dd", res);
                      // this.$router.push({ name: "goal-complete" });
                    })
                    .catch(err => {
                      console.log("error goal mark complete", err);
                    });
                  console.log("feed data", this.email);
                  // this.$router.push({ name: "goal-complete" });
                })
                .catch(err => {
                  console.log("data not found", err);
                });

            }
            else
            {
              for (let i = 0; i < res.data.length; i++) {
                query1 = {
                  query: {
                    endorsementInvitePrgmsId: res.data[i].id,
                     }
                }
                this.$store
                  .dispatch("endorsementInvite/fetchFeeddata", query1)
                  .then(res1 => {
                    console.log("feedback_data", res1);
                    if (res1.data.length !== 0) {
                      for (let i = 0; i < res1.data.length; i++) {
                        if (res1.data[i].endorsementInvitePrgmsId !== 0) {
                          query2 = {
                            query: {
                              endorsementInvitePrgmsId: res1.data[i].endorsementInvitePrgmsId,
                            }
                          }
                          this.$store
                            .dispatch("endorsementInvite/fetchFeeddata", query2)
                            .then(res1 => {
                              console.log(res1);
                              let count = 1;
                              let count1 = 1;
                              for (let i = 0; i < res1.data.length; i++) {
                                if ((new Date(res1.data[i].feedbackSentDate)) > (new Date())) {
                                  if (res1.data[i].emailStatus === 1) {
                                    count = count + res1.data[i].emailStatus;
                                    console.log('C', count);
                                  } else if (res1.data[i].emailStatus === 5 || res1.data[i].emailStatus === 6) {
                                    count1 = count + res1.data[i].emailStatus;
                                    console.log('C', count);
                                  } else {

                                  }
                                }
                              }
                              if ((count - 1)
                                > 0 && (count - 1)
                                <= 5) {
                                this.scheduleInvite = false;
                                this.resetscheduleInvite = true;
                                this.markGoalCompletedEmail = false;
                              } else if (count1 - count > 0) {
                                this.scheduleInvite = false;
                                this.resetscheduleInvite = false;
                                this.markGoalCompletedEmail = true;
                              } else {
                                this.scheduleInvite = true;
                                this.resetscheduleInvite = false;
                                this.markGoalCompletedEmail = false;
                              }
                              for(let k=0;k<res1.data.length;k++){
                                // console.log('res1.data[k]',res1.data[k]["feedbackReceivedDate"]);
                                // this.feedback_sent_dates[k]['ExternalFeedback']["finalDate"]='';
                                //
                                if(res1.data[k]["feedbackReceivedDate"]!==null){
                                  res1.data[k]["finalDate"]=res1.data[k]["feedbackSentDate"]+' / '+res1.data[k]["feedbackReceivedDate"];
                                }else{
                                  res1.data[k]["finalDate"]=res1.data[k]["feedbackSentDate"];
                                }
                              }
                              this.feedback_sent_dates = res1.data;
                              this.edorsementId = res1.data;
                              const query2 = {query: {id: id}}
                              this.$store
                                .dispatch("endorsementInvite/fetchInvitees", query2)
                                .then(res => {
                                  this.email = res.data;
                                  this.compenTencyId = res.data[0].traineeCompetenciesId;
                                  this.inviteUserName=res.data[0].inviteUserName;
                                  this.$store
                                    .dispatch("addSkill/findCompetency",{query:{id:this.compenTencyId}})
                                    .then(traineeCompetency =>{
                                      this.training_duration=traineeCompetency.data[0].trainingDuration;
                                      const characteristicId =  traineeCompetency.data[0].competencyId.split("-")[0];
                                      const competencyId =  traineeCompetency.data[0].competencyId.split("-")[1];
                                      console.log(characteristicId, competencyId);
                                      const competencies = this.CCD[characteristicId].competencies;
                                      console.log(competencies);
                                      const currentCompetency = competencies[competencyId];
                                      console.log('currentCompetency.comp',currentCompetency.comp);
                                      this.skillName = currentCompetency.comp;
                                    }).catch(err => {
                                    console.log("data not found", err);
                                  });
                                  console.log("email dd", res);
                                  // this.$router.push({ name: "goal-complete" });
                                })
                                .catch(err => {
                                  console.log("error goal mark complete", err);
                                });
                              console.log("feed data", this.email);
                              // this.$router.push({ name: "goal-complete" });
                            })
                            .catch(err => {
                              console.log("data not found", err);
                            });
                        }
                      }
                    }
                  })
                  .catch(err => {
                    console.log("data not found", err);
                  });
              }
            }
          })
          .catch(err => {
            console.log("data not found", err);
          });

      },

      cancelSingleEmail(id){
       this.externalFeedbackId=id;
        this.confirmcancelSingleEmail=true;
      },
      confirmCancelSingleEmail(id){
        console.log('id',id);
        this.$store
          .dispatch("external-feedback/get", id)
          .then(res => {
            const query = {query: {externalToken: res.externalToken}}
            console.log("single email data", query);
            this.$store
              .dispatch("invitee-message-id/find", query)
              .then(messageIds => {
                const gapFeedObj = {
                  flag: 'cancelSingleEmail',
                  feedbackId: id,
                  messageId: messageIds.data[0].messageId,
                }
                this.$store
                  .dispatch("external-feedback/patch", [id, gapFeedObj])
                  .then(res1 => {
                    console.log(res1);
                    this.$vs.notify({
                      color: "primary",
                      title: i18n.t('notification.user.skillDetails.emails.cancel.success.c1'),
                      text:  i18n.t('notification.user.skillDetails.emails.cancel.success.c2')
                    });
                    this.confirmcancelSingleEmail=false;
                    this.$store
                      .dispatch("external-feedback/find", {
                        query: {
                          externalToken:res1.externalToken,
                          currentGap: null,
                        }
                      }).then(
                      res2 => {
                        for (let j = 0; j < res2.data.length; j++) {
                          const ZeroGapData = {
                            emailStatus: 1,
                            externalTokenExpired: 1,
                          }
                          this.$store
                            .dispatch("external-feedback/patch", [res2.data[j].id, ZeroGapData])
                            .then(res3 => {
                              window.location.reload();
                            })
                            .catch(err => {
                              console.log("error goal mark complete", err);
                            });
                        }
                        console.log(res2);
                      }
                    ).catch(err => {
                      console.log("single invitee-message-id data not found", err);
                    });
               }).catch(err => {
                  console.log("single invitee-message-id data not found", err);
                });

              })
              .catch(err => {
                console.log("single invitee-message-id data not found", err);
              });
          })
          .catch(err => {
            console.log("single email data not updated", err);
          });
      },
      expireTokenSingleEmail(id){
        this.externalFeedbackId=id;
        this.confirmExpireSingleEmail=true;
      },
      confirmExpireTokenSingleEmail(id){
       console.log('id',id);
        const  extFeedObj = {
          externalTokenExpired: 1,
          emailStatus:6,
        };
        this.$store
          .dispatch("external-feedback/patch", [id, extFeedObj])
          .then(res => {
            this.$vs.notify({
              color: "primary",
              title: i18n.t('notification.user.skillDetails.emails.expire.e1'),
              text:  i18n.t('notification.user.skillDetails.emails.expire.e2')
            });
            this.confirmExpireSingleEmail=false;
            console.log("email resend data updated", res);
          })
          .catch(err => {
            console.log("email resend data not updated", err);
          });
      },
      sendFollowupMail(id){
        console.log('sendFollowupMail',id);
        this.$store
          .dispatch("endorsementInvite/fetchFeeddata",{query:{id:id}})
          .then(feeddata =>{
            this.$store
              .dispatch("endorsement-invite-prgms/find",{query:{id:feeddata.data[0].endorsementInvitePrgmsId}})
              .then(inviteePrgms =>{
                console.log('single invitee prgms data',inviteePrgms);
                this.$store
                  .dispatch("endorsement-invite/find",{query:{id:inviteePrgms.data[0].endorsementInviteId}})
                  .then(InviteeData =>{
                    this.$store
                        .dispatch("invitee-message-id/find",{query:{externalToken:feeddata.data[0].externalToken}})
                        .then(inviteeMessageData =>{
                     console.log('Invitee Data',inviteeMessageData);
                      this.$store
                      .dispatch("addSkill/findCompetency",{query:{id:InviteeData.data[0].traineeCompetenciesId}})
                      .then(traineeCompetency =>{
                        console.log('Invitee Data',traineeCompetency);
                       let followupCountUpdate =feeddata.data[0].followupCount+1;
                        this.$store
                          .dispatch("userManagement/fetchUser",traineeCompetency.data[0].usersId)
                          .then(users =>{
                            const characteristicId =  traineeCompetency.data[0].competencyId.split("-")[0];
                            const competencyId =  traineeCompetency.data[0].competencyId.split("-")[1];
                            console.log(characteristicId, competencyId);
                            const competencies = this.CCD[characteristicId].competencies;
                            console.log(competencies);
                            const currentCompetency = competencies[competencyId];
                            console.log(currentCompetency);
                            this.currentCompetency = currentCompetency;
                            this.InviteSkillName = currentCompetency.comp;
                            console.log('skill name',this.InviteSkillName);
                            this.traineeName=users.firstName+' '+users.lastName;
                            let followUpVariable='';
                            console.log('feeddata.data',feeddata.data);
                            if(feeddata.data.length===1){
                              followUpVariable='benchmark';
                            }else{
                              followUpVariable='followup';
                            }
                            const  extFeedObj = {
                              traineeName: users.firstName+' '+users.lastName,
                              traineeEmail: users.email,
                              playerEmail: users.email,
                              mailType:"followup_invitation_sent",
                              inviteeEmail: InviteeData.data[0].inviteeEmail,
                              inviteUserName: InviteeData.data[0].inviteUserName,
                              skillName:this.InviteSkillName,
                              trainingDuration: traineeCompetency.data[0].trainingDuration,
                              endorsementInvitePrgmsId: inviteePrgms.data[0].id,
                              externalToken:feeddata.data[0].externalToken,
                              feedbackId:feeddata.data[0].id,
                              companyName:window.$cookies.get('companyName'),
                              messageId:inviteeMessageData.data[0].messageId,
                              lang: ((window.$cookies.get('locale') =='es')?'es':'en'),
                              externalTokenExpired: false,
                              feedbackSentDate: feeddata.data[0].feedbackSentDate,
                              followupCount:followupCountUpdate,
                              mailTypeStatus:followUpVariable,
                              emailStatus:2
                            };
                            this.$store
                              .dispatch("external-feedback/patch", [feeddata.data[0].id, extFeedObj])
                              .then(res => {
                                for(let i=0;i<InviteeData.data[0].endorsementInvitePrgms.length;i++){
                                  console.log('InviteeData.data[0].endorsementInvitePrgms',InviteeData.data[0].endorsementInvitePrgms);
                                  let followupStatus={
                                    emailStatus:2,
                                    followupCount:followupCountUpdate,
                                  }
                                  this.$store
                                    .dispatch("endorsementInvite/fetchFeeddata",{query:{endorsementInvitePrgmsId:InviteeData.data[0].endorsementInvitePrgms[i].id, currentGap: null,
                                        feedbackReceivedDate: null}})
                                    .then(res => {
                                      console.log(res.data);
                                      this.$store
                                        .dispatch("external-feedback/patch", [res.data[0].id, followupStatus])
                                        .then(res => { console.log('result',res) })
                                        .catch(err => {
                                          console.log("email resend data not updated", err);
                                        });
                                    })
                                    .catch(err => {
                                      console.log("email resend data not updated", err);
                                    });
                                }
                                this.$vs.notify({
                                  color: "primary",
                                  title: i18n.t('notification.user.skillDetails.emails.sent.e1'),
                                  text:  i18n.t('notification.user.skillDetails.emails.sent.e2')
                                });
                                console.log("email resend data updated", res);
                              })
                              .catch(err => {
                                console.log("email resend data not updated", err);
                              });
                            console.log('Invitee Data',extFeedObj);
                          })
                          .catch(err => {
                            console.log("error goal mark complete", err);
                          })
                      })
                      .catch(err => {
                        console.log("error goal mark complete", err);
                      })}).catch(err => {
                      console.log("error goal mark complete", err);
                    })
                  })
                  .catch(err => {
                    console.log("error goal mark complete", err);
                  })
              })
              .catch(err => {
                console.log("error goal mark complete", err);
              });
          })
          .catch(err => {
            console.log("error goal mark complete", err);
          });
      },
      sentCancelEmailPopupClose(){
        this.sentCancelEmailPopup =false;
      },
      cancelScheduleEmail(data){
         this.scheduleInvite=false;
        this.endorsementInvitePrgms=data[0].endorsementInvitePrgms;
        console.log('datadata',data[0].endorsementInvitePrgms[0].externalFeedback);
        if(data[0].endorsementInvitePrgms[0].externalFeedback.length===0){
          this.sentCancelEmailPopup =true;
           }
        else if(data[0].endorsementInvitePrgms[0].externalFeedback.length>0){
          this.$store
            .dispatch("endorsementInvite/fetchFeeddata",{query:{endorsementInvitePrgmsId:data[0].endorsementInvitePrgms[0].externalFeedback[0].endorsementInvitePrgmsId, $sort: {
                  feedbackSentDate: 1
                }
              }})
            .then(res => {
              console.log('Feedback Data',res.data);
              if((new Date(res.data[res.data.length-1].feedbackSentDate)<new Date())){
                console.log('Hello');
                this.sentCancelEmailPopup =true;
              } else {
                this.confirmscheduleInvite=true;
              }

            })
            .catch(err => {
              console.log("Feedback Data", err);
            });
        }
        else {
          this.confirmscheduleInvite=true;
        }

        this.email=data[0].inviteeEmail;
        this.inviteUserName= this.email=data[0].inviteUserName;
      },
      confirmscancelScheduleEmail(data){
        console.log('sdasdasid',data);
        console.log(this.endorsementInvitePrgms);
        let deletedexternalToken = [];
        this.cancelDisable=false

        for (var i=0;i<data.length;i++) {
          if((new Date(data[i].feedbackSentDate)) > (new Date())) {
            deletedexternalToken.push(data[i].externalToken);
          }
        }
        console.log('External Token',deletedexternalToken);
        if(deletedexternalToken.length!==0) {
          const query = {query: {externalToken: deletedexternalToken}}

          this.$store
            .dispatch("invitee-message-id/find", query)
            .then(res => {
              const gapFeedObj = {
                flag: 'cancelEmail',
                feedbackId: data[0].id,
                messageId: res.data,
                id:data[0].id
              }
              this.$store
                .dispatch("external-feedback/patch", [data[0].id, gapFeedObj])
                .then(res1 => {
                  console.log("external feedback patched", res1);
                  this.$store
                    .dispatch("external-feedback/find", {
                      query: {
                        endorsementInvitePrgmsId: data[0].endorsementInvitePrgmsId,
                        currentGap: null,
                      }
                    })

                    .then(res2 => {
                      console.log("external feedback patched", res2);
                      if (data[1].emailStatus !== 0) {
                        this.$vs.notify({
                          color: "primary",
                          title: i18n.t('notification.user.skillDetails.emails.cancel.error.c1'),
                          text:  i18n.t('notification.user.skillDetails.emails.cancel.error.c2')
                        });
                      } else {
                        this.$vs.notify({
                          color: "primary",
                          title: i18n.t('notification.user.skillDetails.emails.cancel.success.c1'),
                          text:  i18n.t('notification.user.skillDetails.emails.cancel.success.c2')
                        });
                      }
                      for(let k=0;k<this.endorsementInvitePrgms.length;k++) {
                        const query = {query: {endorsementInvitePrgmsId: this.endorsementInvitePrgms[k]['id']}}
                      //  console.log('count',this.endorsementInvitePrgms[k]['id']);
                        this.$store
                          .dispatch("external-feedback/find", query)
                          .then(feedback => {
                            console.log('externalal feedback record', feedback);
                            for (let j = 0; j < feedback.data.length; j++) {
                              //  const date = new Date();
                              if (((new Date(feedback.data[j].feedbackSentDate)) > (new Date()))) {
                                const ZeroGapData = {
                                  emailStatus: 1,
                                  externalTokenExpired: 1,
                                }
                                console.log(feedback.data[j].feedbackSentDate);
                                this.$store
                                  .dispatch("external-feedback/patch", [feedback.data[j].id, ZeroGapData])
                                  .then(res3 => {
                                    this.confirmscheduleInvite = false;
                                    console.log("external feedback patched", res3);
                                  })
                                  .catch(err => {
                                    console.log("error goal mark complete", err);
                                  });
                              }
                            }

                          })
                          .catch(err => {
                            console.log("error goal mark complete", err);
                          });
                       }
                    })
                    .catch(err => {
                      console.log("error goal mark complete", err);
                    });

                })
                .catch(err => {
                  console.log("error goal mark complete", err);
                });
            })

            .catch(err => {
              console.log("error goal mark complete", err);
            });
        }
      },
      resetScheduleEmail(data){
        this.resetscheduleInvite=false;
        this.confirmResetscheduleInvite=true;
        this.endorsementInvitePrgms=data[0].endorsementInvitePrgms;
        console.log('resetData',data);
        this.emailScheduleData=data;
        this.email=data[0].inviteeEmail;
      },
      confirmresetScheduleEmail(data){
        console.log('dataaaa',data);
        const query={query:{id:data[0].traineeCompetenciesId}}
        this.$store
          .dispatch("addSkill/findCompetency", query)
          .then(traineeCompetency => {
              this.$store
                .dispatch("userManagement/fetchUser", traineeCompetency.data[0].usersId)
                .then(users => {
                    console.log(users,data);
                    const query={query:{
                        endorsementInviteId:data[0].id}}
                    this.$store
                      .dispatch("endorsementInvite/fetchInviteePrgms", query)
                      .then(fetchInviteePrgms => {
                        console.log("invitee data", fetchInviteePrgms);

                        const query1={query:{endorsementInvitePrgmsId:fetchInviteePrgms.data[0].id}}
                        this.$store
                          .dispatch("endorsementInvite/fetchFeeddata", query1)
                          .then(fetchFeeddata => {
                            for (var i=0;i<fetchFeeddata.data.length;i++) {
                              if(((new Date(fetchFeeddata.data[i].feedbackSentDate)) > (new Date()))) {
                                const characteristicId =  traineeCompetency.data[0].competencyId.split("-")[0];
                                const competencyId =  traineeCompetency.data[0].competencyId.split("-")[1];
                                console.log(characteristicId, competencyId);
                                const competencies = this.CCD[characteristicId].competencies;
                                console.log(competencies);
                                const currentCompetency = competencies[competencyId];
                                console.log(currentCompetency);
                                this.currentCompetency = currentCompetency;
                                this.InviteSkillName = currentCompetency.comp;
                                console.log('skill name',this.InviteSkillName);
                                const  extFeedObj = {
                                  traineeName: users.firstName+' '+users.lastName,
                                  mailType: "followup",
                                  flag:"RescheduleEmail",
                                  inviteeEmail: data[0].inviteeEmail,
                                  inviteUserName: data[0].inviteUserName,
                                  skillName:this.InviteSkillName,
                                  trainingDuration: traineeCompetency.data[0].trainingDuration,
                                  endorsementInvitePrgmsId: fetchInviteePrgms.data[0].id,
                                  externalToken:fetchFeeddata.data[i].externalToken,
                                  lang: ((window.$cookies.get('locale') =='es')?'es':'en'),
                                  externalTokenExpired: false,
                                  feedbackSentDate: fetchFeeddata.data[i].feedbackSentDate,
                                  emailStatus:0
                                };
                                this.$store
                                  .dispatch("external-feedback/patch", [fetchFeeddata.data[i].id, extFeedObj])
                                  .then(res => {
                                    console.log("email resend data updated", res);
                                  })
                                  .catch(err => {
                                    console.log("email resend data not updated", err);
                                  });
                                console.log(extFeedObj);
                              }
                            }
                            for(let k=0;k<this.endorsementInvitePrgms.length;k++) {
                              const query = {query: {endorsementInvitePrgmsId: this.endorsementInvitePrgms[k]['id']}}
                              //  console.log('count',this.endorsementInvitePrgms[k]['id']);
                              this.$store
                                .dispatch("external-feedback/find", query)
                                .then(feedback => {
                                  console.log('externalal feedback record', feedback);
                                  for (let j = 0; j < feedback.data.length; j++) {
                                    //  const date = new Date();
                                    if (((new Date(feedback.data[j].feedbackSentDate)) > (new Date()))) {
                                      const ZeroGapData = {
                                        emailStatus: 0,
                                        externalTokenExpired: 0,
                                      }
                                      console.log(feedback.data[j].feedbackSentDate);
                                      this.$store
                                        .dispatch("external-feedback/patch", [feedback.data[j].id, ZeroGapData])
                                        .then(res3 => {
                                          this.confirmscheduleInvite = false;
                                          console.log("external feedback patched", res3);
                                        })
                                        .catch(err => {
                                          console.log("error goal mark complete", err);
                                        });
                                    }
                                  }

                                })
                                .catch(err => {
                                  console.log("error goal mark complete", err);
                                });
                            }

                            this.confirmResetscheduleInvite=false;
                            this.$vs.notify({
                              color: "primary",
                              title: i18n.t('notification.user.skillDetails.emails.schedule.success.c1'),
                              text:  i18n.t('notification.user.skillDetails.emails.schedule.success.c2')
                            });
                            console.log("feed data",fetchFeeddata);
                            // this.$router.push({ name: "goal-complete" });
                          })
                          .catch(err => {
                            this.$vs.notify({
                              color: "primary",
                              title: i18n.t('notification.user.skillDetails.emails.schedule.error.c1'),
                              text:  i18n.t('notification.user.skillDetails.emails.schedule.error.c2')
                            });
                            console.log("error fetch Feed data ", err);
                          });
                      })
                      .catch(err => {
                        console.log("error goal mark complete", err);
                      });
                  }
                )
                .catch(err => {
                  console.log("users complete", err);
                });
            }
          )
          .catch(err => {
            console.log("users complete", err);
          });
      },
      formatDate(sentDate) {
        let date = new Date(sentDate)
        // console.log("sent date", date);
        date = `${date.getFullYear()  }-${  date.getMonth() + 1  }-${  date.getDate()}`;
        return date;
      },
      addAnotherSkill() {
        this.goalCompletedPopup = false
        this.$router.push({name: "add-skill"});
      },
      markGoalConfirmComplete(){
        this.markGoalCompletedConfirmation=true;
      },
      markGoalComplete() {
        this.markGoalCompletedConfirmation=false;
        const id = this.$route.params.traineeCompetenciesId;
        const goalCompleteObj = {
          id,
          progressStatus: "complete"
        };
        this.$store
          .dispatch("endorsementInvite/markGoalComplete", goalCompleteObj)
          .then(res => {
            const query={query:{traineeCompetenciesId:id}}
            this.$store
              .dispatch("endorsementInvite/fetchInvitees", query)
              .then(res => {
                for (let i=0;i<res.data.length;i++) {
                  this.$store
                    .dispatch("endorsement-invite-prgms/find",{query:{endorsementInviteId:res.data[i].id}})
                    .then(res => {
                      console.log('All InviteeId',res);
                      for (let j=0;j<res.data.length;j++) {
                        this.$store
                          .dispatch("external-feedback/find", {query: {endorsementInvitePrgmsId: res.data[j].id,
                              emailStatus:{$ne:4}}})
                          .then(res1 => {
                            console.log('res1',res1.data);
                            let deletedexternalToken = [];
                            for (let k=0;k<res1.data.length;k++) {

                                deletedexternalToken.push(res1.data[k].externalToken);

                            }
                            console.log('deletedexternalToken',deletedexternalToken);
                            const query = {query: {externalToken: deletedexternalToken}}
                            this.$store
                              .dispatch("invitee-message-id/find", query)
                              .then(res => {
                                const gapFeedObj = {
                                  flag: 'MarkGoalCompleted',
                                  feedbackId: res.data[0].id,
                                  messageId: res.data
                                }

                                console.log('invitee-message-id',gapFeedObj);
                                this.$store
                                  .dispatch("external-feedback/patch", [res1.data[0].id, gapFeedObj])
                                  .then(res2 => {
                                    console.log(res2);
                                    this.$store
                                      .dispatch("external-feedback/find", {query: {endorsementInvitePrgmsId: res2.endorsementInvitePrgmsId}})
                                      .then(res3 => {
                                        console.log(res3.data);
                                        for (let l = 0; l < res3.data.length; l++) {
                                          //  const date = new Date();
                                          if ((new Date(res3.data[l].feedbackSentDate)) > (new Date())) {
                                            const ZeroGapData = {
                                              emailStatus: 6,
                                              externalTokenExpired:1
                                            }
                                            console.log(res3.data[l].feedbackSentDate);
                                            this.$store
                                              .dispatch("external-feedback/patch", [res3.data[l].id, ZeroGapData])
                                              .then(res3 => {
                                                console.log("external feedback patched", res3);
                                              })
                                              .catch(err => {
                                                console.log("error goal mark complete", err);
                                              });
                                          }else{
                                            const ZeroGapData = {
                                              emailStatus: 6,
                                              externalTokenExpired:1
                                            }
                                            console.log(res3.data[l].feedbackSentDate);
                                            this.$store
                                                .dispatch("external-feedback/patch", [res3.data[l].id, ZeroGapData])
                                                .then(res3 => {
                                                  console.log("external feedback patched", res3);
                                                })
                                                .catch(err => {
                                                  console.log("error goal mark complete", err);
                                                });
                                          }
                                        }
                                      })
                                      .catch(err => {
                                        console.log("error goal mark complete", err);
                                      });
                                  })
                                  .catch(err => {
                                    console.log("error goal mark complete", err);
                                  });

                              })

                                .catch(err => {
                                console.log("error goal mark complete", err);
                              });

                            // console.log('External Feedback Data', deletedexternalToken);
                          })
                          .catch(err => {
                            console.log("error goal mark complete", err);
                          });
                      }
                    })
                    .catch(err => {
                      console.log("error goal mark complete", err);
                    });
                }
                console.log('All InviteeId',res);
              })
              .catch(err => {
                console.log("error goal mark complete", err);
              });

            this.goalCompletedPopup = true;
          })
          .catch(err => {
            console.log("error goal mark complete", err);
          });
      },
      sendInvite() {
        console.log("send invite btn");
        const id = this.$route.params.traineeCompetenciesId;
        this.$router.push({
          name: "endorsement-invite",
          params: { traineeCompetenciesId: id }
        });
      },
      minGap(extFeed) {
        let min = 0;
        for (const ef in extFeed) {
          if (parseInt(extFeed[ef]["currentGap"]) < min) {
            min = parseInt(extFeed[ef]["currentGap"]);
          }
        }
        return min;
      },
      maxGap(extFeed) {
        let max = 0;
        for (const ef in extFeed) {
          if (parseInt(extFeed[ef]["currentGap"]) > max) {
            max = parseInt(extFeed[ef]["currentGap"]);
          }
        }
        return max;
      },
      prepareData(resData ,inviteeEmailData) {
        console.log('resData',resData);
        for (const pm in this.progress_measures_list) {
          this.endorsementNewObj[pm] = {
            series: [],
            chartOptions: {
              chart: {
                height: 350,
                zoom: {
                  enabled: false
                },

              },
              legend: {show: true,onItemClick: {
                  toggleDataSeries: false
                }},
              colors: this.themeColors,
              dataLabels: {
                enabled: false,
              },
              markers: {
                size: 4,
                colors: ["#808080"],
                strokeColors: "#fff",
                strokeWidth: 2,
                hover: {
                  size: 12,
                }
              },
              stroke: {
                curve: "smooth"
              },
              title: {
                text: '', // this.progress_measures_list[pm]["pm"],
                align: "left"
              },
              grid: {
                row: {
                  colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
                  opacity: 0.5
                }
              },
              xaxis: {
                categories: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30],
              },
              tooltip: {
                enabled: true,
                custom: function({ series, seriesIndex, dataPointIndex, w }) {
                  // Get the custom data we injected into the data point
                  const dataPoint = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
                  const raterName = w.globals.seriesNames[seriesIndex];
                  const note = dataPoint.note || 'No note provided';
                  const rating = dataPoint.rawGap;
                  
                  // Format the rating into words
                  let ratingText = '';
                  if (rating === 0) ratingText = 'Goal Reached (No Gap)';
                  else if (rating > 0) ratingText = rating + ' (Closing Gap)';
                  else if (rating < 0) ratingText = rating + ' (Gap Bigger)';
                  else ratingText = 'No Rating';

                  // Return a nicely formatted HTML box
                  return `<div style="padding: 12px; font-family: inherit; font-size: 13px; max-width: 250px; white-space: normal; line-height: 1.5;">
                      <div style="margin-bottom: 5px;"><strong>Advisor:</strong> ${raterName}</div>
                      <div style="margin-bottom: 5px;"><strong>Note:</strong></div>
                      <div style="color: #555;"><i>"${note}"</i></div>
                    </div>`;
                }
              },
              scaleLabel: {
                display: false,
                labelString: 'x axis'
              },
              yaxis: {
                show: true,
                tickAmount: 2,
                min: -100,
                max: 100,
                labels: {
                  formatter:
                    function (value,opts) {
                    // let count=0;
                    // let a=[];
                    if(value ==100){
                      return   i18n.t('NoGap');
                    }
                    else if(value >0 && value <100){
                        return   i18n.t('GapSmaller');
                    }
                    else if(value===0){
                        return    i18n.t('Benchmark_1');
                    }
                    else if(value<0){
                      return   i18n.t('GapBigger');
                    }
                    else {
                      return  i18n.t('NoRating');
                    }
                  }
                },
                forceNiceScale: false,
                decimalsInFloat:false,
                title: {
                  text: this.$t('Progress'),
                  style: {
                    fontSize: "15px",
                    fontFamily: "Montserrat, Helvetica, Arial, sans-serif"
                  }
                }
              }
            }
          };

          const endorsementInviteData=resData[this.progress_measures_list[pm].pmId];
          this.inviteeEmail=inviteeEmailData;
            for(const x in endorsementInviteData){

              this.endorsementNewObj[pm]["pm"] = this.progress_measures_list[pm].pm
              this.endorsementNewObj[pm]["pmId"] = this.progress_measures_list[pm].pmId
              const array= endorsementInviteData[x].email.split("@");
              this.endorsementNewObj[pm].series.push({
                pmId: this.progress_measures_list[pm].pmId,
                pm: this.progress_measures_list[pm].pm,
                pmMap: this.progress_measures_list[pm].pmMap,
                name:array[0],
                email:endorsementInviteData[x].email,
                endorsementInviteId:endorsementInviteData[x].endorsementInviteId
              });
              const eF = [];
              var z=1;

              for (const y in endorsementInviteData[x].externalFeedback ) {
               if(endorsementInviteData[x].externalFeedback[y].currentGap !== null) {
                    var      benchmarkGap=endorsementInviteData[x].externalFeedback[0].currentGap;
                 if(endorsementInviteData[x].externalFeedback[0].currentGap===0){
                   benchmarkGap=-1;
                 }else{

                      benchmarkGap=endorsementInviteData[x].externalFeedback[0].currentGap;
                    }


                 console.log('benchmarkGap',benchmarkGap)

                  const currentGapValue = endorsementInviteData[x].externalFeedback[y].currentGap;
                  const noteString = endorsementInviteData[x].externalFeedback[y].notesDescription;

                  if (endorsementInviteData[x].externalFeedback[y].feedbackReceivedDate !== null) {
                    eF.push({
                      y: ((benchmarkGap - currentGapValue) * 100) / benchmarkGap,
                      x: z++,
                      note: noteString,      // <--- INJECT NOTE
                      rawGap: currentGapValue // <--- INJECT RAW RATING
                    });
                  }
                  else{
                    eF.push({
                      y: ((benchmarkGap - currentGapValue) * 100) / benchmarkGap,
                      x: z++,
                      note: noteString,      // <--- INJECT NOTE
                      rawGap: currentGapValue // <--- INJECT RAW RATING
                    });
                  }
                }
              }
              this.endorsementNewObj[pm]["series"][this.endorsementNewObj[pm]["series"].length - 1]["minGap"] = 8;
              this.endorsementNewObj[pm]["series"][this.endorsementNewObj[pm]["series"].length - 1]["maxGap"] = 8;
              console.log('eF Data',eF );
              this.endorsementNewObj[pm]["series"][this.endorsementNewObj[pm]["series"].length - 1]["data"] = eF;
              this.$store
                .dispatch("endorsementInvite/updateChartData", this.endorsementNewObj)
                .catch(err => {
                  console.log(err);
                });
            }
            console.log('data',this.endorsementNewObj);


          //    var z=1;

            //   // console.log('data',this.endorsementNewObj);
            //
            // this.inviteeEmail = resData[i];
            // var feedback_array = [];




          // for (const x in resData) {
          //   this.inviteeEmail=resData;
          //   var feedback_array=[];
          //
          //     if (this.progress_measures_list[pm].pmId === resData[x]) {
          //       console.log("progress_measures_list",this.progress_measures_list)
          //       this.endorsementNewObj[pm]["pm"] = this.progress_measures_list[pm].pm
          //       this.endorsementNewObj[pm]["pmId"] = this.progress_measures_list[pm].pmId
          //       console.log('data email',this.progress_measures_list[pm].pmMap);
          //       this.endorsementNewObj[pm].series.push({
          //         pmId: this.progress_measures_list[pm].pmId,
          //         pm: this.progress_measures_list[pm].pm,
          //         pmMap: this.progress_measures_list[pm].pmMap,
          //         email: resData[x]["inviteeEmail"],
          //       });
          //       console.log('endorsementNewObj',this.endorsementNewObj);
          //       const eF = [];
          //       //  const benchmarkGap= 10;
          //       //  var benchmarkGap = resData[x]["endorsementInvitePrgms"][y]["externalFeedback"][0]["currentGap"]
          //       // if(1<benchmarkGap<=10){
          //       //    benchmarkGap = resData[x]["endorsementInvitePrgms"][y]["externalFeedback"][0]["currentGap"];
          //       //   console.log('benchmarkGap',benchmarkGap);
          //       //
          //       // }
          //       // else{
          //       //    benchmarkGap = 1;
          //       // }
          //       //const benchmarkGap = 1;
          //
          //       // const minGap = this.minGap(resData[x]["endorsementInvitePrgms"][y]["externalFeedback"]);
          //       // const maxGap = this.maxGap(resData[x]["endorsementInvitePrgms"][y]["externalFeedback"]);
          //       //console.log('sort data',resData)
          //       // console.log(   'sort data',resData.sort((a, b) => b.date - a.date))
          //       var i=1;
          //     var sorted= resData[x]["endorsementInvitePrgms"][y]["externalFeedback"].sort(function(a, b){return b.length - a.length});
          //
          //       feedback_array.push(resData[x]["endorsementInvitePrgms"][y]["externalFeedback"].length);
          //       console.log('`feedbacklength`',feedback_array);
          //       for (const z in resData[x]["endorsementInvitePrgms"][y]["externalFeedback"]) {
          //
          //
          //
          //
          //
          //         //  console.log('Hello',resData[x]["endorsementInvitePrgms"][y]["externalFeedback"][z]["currentGap"]);
          //         if(resData[x]["endorsementInvitePrgms"][y]["externalFeedback"][z]["currentGap"] !== null) {
          //           //    console.log(benchmarkGap);
          //           var      benchmarkGap=resData[x]["endorsementInvitePrgms"][y]["externalFeedback"][0]["currentGap"];
          //           if(benchmarkGap!==null){
          //
          //             benchmarkGap=resData[x]["endorsementInvitePrgms"][y]["externalFeedback"][0]["currentGap"];
          //           }
          //           else{
          //             benchmarkGap=10;
          //           }
          //           if (resData[x]["endorsementInvitePrgms"][y]["externalFeedback"][z]["feedbackReceivedDate"] !== null) {
          //             console.log(benchmarkGap);
          //             eF.push({
          //               y:((benchmarkGap - resData[x]["endorsementInvitePrgms"][y]["externalFeedback"][z]["currentGap"]) * 100) / benchmarkGap,
          //               x:i++,
          //             });
          //           }
          //           else{
          //             eF.push({
          //               y:((benchmarkGap - resData[x]["endorsementInvitePrgms"][y]["externalFeedback"][z]["currentGap"]) * 100) / benchmarkGap,
          //               x: i++
          //             });
          //           }
          //         }
          //       }
          //       //   this.endorsementNewObj[pm]["series"][this.endorsementNewObj[pm]["series"].length - 1]["minGap"] = 8;
          //       // this.endorsementNewObj[pm]["series"][this.endorsementNewObj[pm]["series"].length - 1]["maxGap"] = 8;
          //       console.log('eF Data',eF );
          //       this.endorsementNewObj[pm]["series"][this.endorsementNewObj[pm]["series"].length - 1]["data"] = eF;
          //
          //       this.$store
          //         .dispatch("endorsementInvite/updateChartData", this.endorsementNewObj)
          //         .catch(err => {
          //           console.log(err);
          //         });
          //     }
          //
          // }
        }
        // console.log("new obj", this.inviteeEmail);
      },
      removeInvited(id){
        const eiQuery={
          id:id,
          status:1
        }
        this.$store.dispatch("endorsementInvite/patchInvitees",eiQuery)
        .then(res1 => {
          if(res1 === 'success'){
            this.$vs.notify({
              color: "primary",
              title: i18n.t('notification.user.skillDetails.rater.deactivate.success.a1'),
              text:  i18n.t('notification.user.skillDetails.rater.deactivate.success.a2')
            });
            let eipQuery = {query:{endorsementInviteId:id}}
            this.$store.dispatch("endorsementInvite/fetchInviteePrgms",eipQuery).
            then(res2 => {
              if(res2.data.length){
                for(let i=0;i<res2.data.length;i++){
                  let efbQuery = {query:{endorsementInvitePrgmsId:res2.data[i].id}};
                  this.$store.dispatch("endorsementInvite/fetchFeeddata",efbQuery).
                  then(res3 => {
                    if(res3.data.length){
                      for(let i=0;i<res3.data.length;i++){
                        let efbPatchQuery = {
                          id : res3.data[i].id,
                          emailStatus : 1
                        }
                        this.$store.dispatch("endorsementInvite/patchFeeddata",efbPatchQuery).
                        then(res4 => {

                        })
                      }
                    }
                  })
                }
              }
              console.log("programs are",res2.data);
            })
          }
        })
        .catch(e => {
          cosole.log(e);
          this.$vs.notify({
            title: i18n.t('notification.user.skillDetails.rater.deactivate.error.a1'),
            text:  i18n.t('notification.user.skillDetails.rater.deactivate.error.a2'),
            color: "danger"
          });
        })
      },
      reactiveInvitee(id){
        const eiQuery={
          id:id,
          status:0
        }
        this.$store.dispatch("endorsementInvite/patchInvitees",eiQuery)
        .then(res1 => {
          if(res1 === 'success'){
            this.$vs.notify({
              color: "primary",
              title: i18n.t('notification.user.skillDetails.rater.activate.success.a1'),
              text:  i18n.t('notification.user.skillDetails.rater.activate.success.a2')
            });
          }
        })
        .catch(e => {
          this.$vs.notify({
            title: i18n.t('notification.user.skillDetails.rater.activate.error.a1'),
            text:  i18n.t('notification.user.skillDetails.rater.activate.error.a2'),
            color: "danger"
          });
          console.log(e)
        })
      }
    },
    mounted() {
      this.terminology=this.terminology;
    },
    created() {
      this.terminology= window.$cookies.get('terminology');

      /***********Endorsement Chart***************/
      //const id = this.$route.params.traineeCompetenciesId;
      // const traineeCompetenciesId = this.$route.params.traineeCompetenciesId;
      // console.log(traineeCompetenciesId);
      // const queryObj = {
      //   traineeCompetenciesId
      // };
      // this.$store
      //   .dispatch("endorsementInvite/fetchInvitees", { query: queryObj })
      //   .then(res1 => {
      // this.$store
      //   .dispatch("trainee-competencies-prgms/find", {
      //     query: { traineeCompetenciesId: id }
      //   })
      //   .then(res3 => {
      //     console.log("progress measure", res3.data);
      //     for (const pm in res3.data) {
      //       if(res3.data[pm].progressMeasureId.includes('custom')) {
      //         this.progress_measures_list.push({
      //           id: res3.data[pm].progressMeasureId,
      //           pm: res3.data[pm].progressMeasure,
      //           pmMap: res3.data[pm].progressMeasure
      //         })
      //       } else {
      //         const s = (res3.data[pm].progressMeasureId).split("-")
      //         const charId = s[0]
      //         const compId = s[1]
      //         const pmsId = s[2]
      //         console.log(charId, compId, pmsId)
      //         this.progress_measures_list.push({
      //           id: pmsId,
      //           pm: this.CCD[charId].competencies[compId].progressMeasures[pmsId].pm,
      //           pmMap: this.CCD[charId].competencies[compId].progressMeasures[pmsId].pmMap
      //         })
      //       }
      //       console.log('prepareData',res1.data);
      //       this.prepareData(res1.data);
      //
      //     }
      //   })
      //   .catch(err3 => {
      //     console.log("could not find progress measure", err3);
      //   });
      //   })
      //   .catch(err1 => {
      //     console.log("error finding all invitees", err1);
      //   });
      /***********Endorsement Chart***************/
      const traineeCompetenciesId = this.$route.params.traineeCompetenciesId;
      console.log(traineeCompetenciesId);
      const queryObj = {
        traineeCompetenciesId
      };
      this.$store
        .dispatch("endorsementInvite/fetchInvitees", { query: queryObj })
        .then(res1 => {

          const id = this.$route.params.traineeCompetenciesId;
          this.$store
            .dispatch("trainee-competencies-prgms/find", {
              query: { traineeCompetenciesId: id }
            })
            .then(res3 => {
              for (const pm in res3.data) {
                if(res3.data[pm].progressMeasureId.includes('custom')) {
                  this.progress_measures_list.push({
                    id: res3.data[pm].progressMeasureId,
                    pmId: res3.data[pm].progressMeasureId,
                    pm: res3.data[pm].progressMeasure,
                    pmMap: res3.data[pm].progressMeasure, // Added fallback mapped property
                    title: ""
                  });
                } else {
                  const s = res3.data[pm].progressMeasureId.split("-");
                  const charId = s[0];
                  const compId = s[1];
                  const pmsId = s[2];
                  
                  let pmText = "Progress Measure";
                  let pmMapText = "Progress Measure";
                  let pmTitleText = "";
                  
                  // Query data with PCI Priority Logic
                  const foundPm = this.findProgressMeasureData(res3.data[pm].progressMeasureId);
                  
                  if (foundPm) {
                      pmText = foundPm.pm || pmText;
                      pmMapText = foundPm.pmMap || pmMapText;
                      pmTitleText = foundPm.title || ""; // Capture title from prioritised dictionary files
                  } else if (this.CCD && this.CCD[charId] && this.CCD[charId].competencies && this.CCD[charId].competencies[compId] && this.CCD[charId].competencies[compId].progressMeasures && this.CCD[charId].competencies[compId].progressMeasures[pmsId]) {
                      // Safe lookup fallback to basic i18n
                      pmText = this.CCD[charId].competencies[compId].progressMeasures[pmsId].pm || pmText;
                      pmMapText = this.CCD[charId].competencies[compId].progressMeasures[pmsId].pmMap || pmMapText;
                      pmTitleText = this.CCD[charId].competencies[compId].progressMeasures[pmsId].title || "";
                  }
                  
                  this.progress_measures_list.push({
                    id: pmsId,
                    pmId: res3.data[pm].progressMeasureId,
                    pm: pmText,
                    pmMap: pmMapText,
                    title: pmTitleText
                  });
                }
              }
              let prepareData =[];
                prepareData =res1.data;

                console.log(res1.data,"res1.data");
              const pgrms = {};

              prepareData.forEach(pd => {
                const endorsementInvitePrgms = pd.endorsementInvitePrgms;

                endorsementInvitePrgms.forEach(eip => {

                  if(!pgrms[eip.progressMeasureId]) {
                    pgrms[eip.progressMeasureId] = [];
                  }

                  pgrms[eip.progressMeasureId].push({
                    email: pd.inviteeEmail,
                    externalFeedback: eip.externalFeedback,
                    externalFeedbackCount: eip.externalFeedback.length,
                    endorsementInviteId: eip.endorsementInviteId

                  });
                });
              });

              Object.keys(pgrms).forEach(progressMeasure => {
                const progressMeasureData = pgrms[progressMeasure];

                pgrms[progressMeasure] = progressMeasureData.sort(function(a, b){
                  return b.externalFeedbackCount - a.externalFeedbackCount;
                })
              })
              console.log('pgrms',pgrms)
              // var array = Object.keys(pgrms)
              //   .map(function(key) {
              //     return pgrms[key];
              //   });
              // console.log('prepareDataddsd',array);
              this.prepareData(pgrms,res1.data);
            })
            .catch(err3 => {
              console.log("could not find progress measure", err3);
            });
        })
        .catch(err1 => {
          console.log("error finding all invitees", err1);
        });
    }
  };
</script>

<style scoped>
  .truncate-pm {
    width: 80%;
    white-space: normal !important;
    margin-left: 1.5rem;
  }
  .no-box-shadow {
    box-shadow: none !important;
  }
  .t-sd {
    white-space: normal !important;
  }
  .skill-icon {
    width: 25px;
    height: 25px;
  }
  .items-center {
    text-align: center;
    text-align: -moz-center;
    text-align: -webkit-center;
  }

  table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 80%;
    margin-left:10%;margin-right:10%;
  }

  .left {
    border: 1px solid #ffffff;
    text-align: left;
    padding: 8px;
  }
  .right {
    border: 1px solid #ffffff;
    text-align: right;
    padding: 8px;
  }
  .con-vs-dialog .vs-dialog footer .vs-button:last-of-type {
    /* border-color: rgba(0, 0, 0, 0.2) !important; */
    display: none;
  }
  .vs-button-flat {
    display: none;
  }
  .con-vs-popup .vs-popup {
    -webkit-transition: all .2s;
    transition: all .2s;
    z-index: 100;
    width:400px ;
    margin: 10px;
    max-width: 400px;
    max-height: calc(100% - 30px);
    border-radius: 6px;
    -webkit-box-shadow: 0 5px 20px 0 rgba(0,0,0,.1);
    box-shadow: 0 5px 20px 0 rgba(0,0,0,.1);
    background: #fff;
    -webkit-animation: rebound .3s;
    animation: rebound .3s;
  }
  tr:nth-child(even) {
    background-color: #ffffff;
  }
</style>
